/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { useClassName } from "./Flex.mappers";
import { FlexProps } from "./FlexProps";

/**
 * Renders the Flex component to show children in a horizontal or vertical row.
 * @param props The properties.
 * @returns The Flex component.
 */
export const Flex: React.FC<FlexProps> = props => {
    // Extracting 'className' and 'horizontal' so they are excluded from 'restProps'
    const { as: Root = "div", className, children, horizontal, ...restProps } = props;
    const rootClassName = useClassName(props);

    return <Root className={rootClassName} {...restProps}>{children}</Root>;
};
